module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGe50de8b3df82349da24df50f6310d2b2.e50de8b3.png";